import { useState } from 'react';
import Slider from 'rc-slider';
import 'rc-slider/assets/index.css';
import styled from 'styled-components';

import BottomModal from '../../../components/modal/BottomModal';
import {
  CancleButton,
  ConfirmButton,
  ModalCloseButton,
  ModalFooter,
  ModalHeader,
  ModalTitle,
} from '../../../components/modal/Modal.style';
import { Section } from './SelectModal.styles';

// 라벨 함수 공용
const currentYear = new Date().getFullYear(); // 현재년도 자동 계산

export const getRangeLabel = ([start, end]: [number, number]) => {
  if (start === 1980 && end === 2025) {
    return '전체';
  }

  if (start !== 1980 && end === 2025) {
    const age = currentYear - start;
    return `노후 ${age}년 이하`;
  }

  if (start === 1980 && end !== 2025) {
    const age = currentYear - end;
    return `노후 ${age}년 이상`;
  }

  if (start !== 1980 && end !== 2025) {
    const ageStart = currentYear - end;
    const ageEnd = currentYear - start;
    return `노후 ${ageStart}년 ~ ${ageEnd}년`;
  }

  return '';
};
export const getSubLabel = ([start, end]: [number, number]) => {
  if (start === 1980 && end === 2025) {
    return `${end} 이전 건축`;
  }

  if (start !== 1980 && end === 2025) {
    return `${start}년 이후 건축`;
  }

  if (start === 1980 && end !== 2025) {
    return `${end}년 이전 건축`;
  }

  return `${start} ~ ${end} 이내 건축`;
};

interface Props {
  selected: { start: string; end: string }; // 선택된 값
  onApply: (range: { start: string; end: string }) => void;
  onClose: () => void;
}

const YearRangeSliderModal = ({ selected, onApply, onClose }: Props) => {
  const [yearRange, setYearRange] = useState<[number, number]>([
    Number(selected.start) || 1980,
    Number(selected.end) || 2025,
  ]);

  const handleChange = (value: number | number[]) => {
    if (Array.isArray(value)) setYearRange(value as [number, number]);
  };

  const handleApply = () => {
    onApply({
      start: yearRange[0].toString(),
      end: yearRange[1].toString(),
    });
    onClose();
  };

  return (
    <BottomModal onClose={onClose}>
      <ModalHeader>
        <ModalTitle>노후년도</ModalTitle>
        <ModalCloseButton
          onClick={onClose}
          src="/assets/images/close/close-dark-gray.svg"
          alt="close"
        />
      </ModalHeader>
      <Section>
        <Inner>
          <TopLabel>
            <TopLabel01>{getRangeLabel(yearRange)}</TopLabel01>
            <TopLabel02>{getSubLabel(yearRange)}</TopLabel02>
          </TopLabel>
          <SliderWrap>
            <Slider
              range
              min={1980}
              max={2025}
              value={yearRange}
              onChange={handleChange}
            />
            <SliderLabel>
              <span>1980</span>
              <span>2025</span>
            </SliderLabel>
          </SliderWrap>
        </Inner>
      </Section>
      <ModalFooter>
        <CancleButton onClick={onClose}>취소</CancleButton>
        <ConfirmButton onClick={handleApply}>적용</ConfirmButton>
      </ModalFooter>
    </BottomModal>
  );
};

export default YearRangeSliderModal;

const Inner = styled.div`
  display: flex;
  padding: 0 0 24px;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  align-self: stretch;
`;

const SliderWrap = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  border-radius: 8px;
  background: #fff;
  justify-content: space-between;

  .rc-slider-track {
    background-color: #008aff;
  }
  .rc-slider-rail {
    background-color: rgba(112, 115, 124, 0.08);
  }
  .rc-slider-handle {
    width: 16px;
    height: 16px;
    filter: drop-shadow(0 0 1px rgba(0, 0, 0, 0.08))
      drop-shadow(0 0 1px rgba(0, 0, 0, 0.08))
      drop-shadow(0 0 2px rgba(0, 0, 0, 0.12));
    background-color: #fff;
    opacity: 1;
    border: solid 1px #e5e8ea;
  }
  .rc-slider {
    width: calc(100% - 16px);
  }
`;

const TopLabel = styled.div`
  display: flex;
  padding: 16px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 4px;
  align-self: stretch;
  border-radius: 8px;
  background: #f7f8fc;
`;

const TopLabel01 = styled.div`
  align-self: stretch;
  color: #616161;
  text-align: center;
  font-size: 14px;
  font-weight: 500;
  line-height: 145%; /* 20.3px */
  letter-spacing: -0.28px;
`;

const TopLabel02 = styled.div`
  align-self: stretch;
  color: #222;
  text-align: center;
  font-size: 16px;
  font-weight: 500;
  line-height: 145%; /* 23.2px */
  letter-spacing: -0.32px;
`;

const SliderLabel = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
  span {
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: 145%; /* 17.4px */
    letter-spacing: -0.24px;
    color: rgba(55, 56, 60, 0.61);
  }
`;
